//引入
import { JSEncrypt } from "jsencrypt";

/*
 *@描述: 加密参数
 *@参数: 需要加密的参数
 *@作者: 金涛
 *@日期: 2022-06-24 18:42:27
 */
export function setEncryption(param) {
  // 后台给的公钥
  const publicKey =
    "MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKerP1yT+eB/w7Tq1ViV9n/gqOoR/pEOv/dPkANXPCq6N6VjQlGKWhLP95y+nMAK8AgubhQb+bmzSK0Ohx3E82Ye29+XtTOoev3lrK+Ij1KB/BziWZY/Rydf4xf+ppUbJKVymjBkIfueA5cu+/3gHD8TqOhGwANRIqpJ6WpNIw5VAgMBAAECgYABr5wkfyxtEHvUTuQ0TtW6tXSdXe70YHSXtQoarn7hYxv6IsRg84YyWDsCLXyABdwiCO18cEeTkXTyoInFR9y2rvJO+OGsXmSF92ZNommifjAe3DhGsQyKAhlMPJtPYM+38eGbnaJaGNNVlXFurv0baGnVfopl5yE1az4CveOmgQJBAPNJ0zv0FdLUXPKk9dOZKruIme217vKAvkfkpVvzZgpQnYPA1xW7fbjR8QAMcgPfZSPGhxX3UvuRmFOI5OVLZWECQQCwbfPPp8TZk9fA0ClOsKgJzmTpUhwaL0ZFttblsT9VjKXOZDoihB6m3yKUUceFTWa/ntJ6Pv/D2RyqEg6Sz1l1AkBTij4mkCIOSy2/hDWFe0rZKobwwVBTpTGxrim58VJQqG3uGAHDTKZXGIAQ7DUab1NjfYBVYp/0EoKj7JXsxn8BAkAhI6YGPUcWb1S5XOBFbZ1Cqkf+I3Qv3u1eLufSoSZ6VT7Xs6/Px+1R/tup7GqDuXQxTg3O9IJqMR/XOikOnm/5AkEAl4o3FBpQBQEeAtgaCNGv2hw/PLpRA9p/PscDijqNvK1c9X+G1N4DdUfs1y6VmpLDG03Od05OB0iK5j2eUjDOmA==";
  let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey); // 设置公钥

  return encryptor.encrypt(JSON.stringify(param)); // 对密码进行加密
}
